require('./library/js/lazy');